@import "~@uipath/apollo-core/src/scss/base-host.scss";
@import "~@uipath/apollo-core/src/scss/_variables.scss";
@import url("https://fonts.googleapis.com/icon?family=Material+Icons|Material+Icons+Outlined");

.alert-bar-root {
  display: flex;
  &.warning {
    background-color: var(--color-warning-background);
    border: 1px solid var(--color-warning-icon);
  }

  &.info {
    background-color: var(--color-info-background);
    border: 1px solid var(--color-info-foreground);
  }

  &.success {
    background-color: var(--color-success-background);
    border: 1px solid var(--color-success-icon);
  }

  &.error {
    background-color: var(--color-error-background);
    border: 1px solid var(--color-error-icon);
  }

  &.trial {
    background-color: $color-blue-700;
  }

  .alert-bar-content {
    display: flex;
    padding-left: $pad-l;
    width: 100%;
  }

  .alert-bar-warning,
  .alert-bar-icon {
    display: flex;
    padding-right: $pad-l;
    padding-top: 8px;
  }
}

.alert-bar-left,
.alert-bar-right {
  display: flex;
}

.alert-bar-right {
  padding-top: $pad-s;
  padding-right: $pad-l;
}

.pt-slot-content {
  display: flex;
  flex: 1;
  font-family: $font-normal;
  color: var(--color-foreground);
  font-style: normal;
  font-size: $font-m-size;
  line-height: $font-m-line-height;
  padding: $pad-xl 5px $pad-xl 0px;
}

.trial-content {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  margin-right: 22px;
  height: 48px;
  font-family: $font-normal;

  &.left-aligned {
    margin-left: $pad-xl;
  }

  & > .trial-description {
    color: $color-white;
    font-style: normal;
    font-size: $font-m-size;
    font-weight: normal;
    line-height: $font-m-line-height;
    font-family: $font-normal;
    margin-right: 26px;
  }

  & > .pt-slot-content {
    display: flex;
    flex: 1;
    color: $color-white;
    font-style: normal;
    font-size: $font-m-size;
    line-height: $font-m-line-height;
    padding: $pad-xl 5px $pad-xl 0px;
  }
}
